<template>
    <div class="self-goldcard-block" style="min-height: 100%">
        <div v-if="this.cardType === 'gold' || !cardInfo" class="self-goldcard-block-hero">
            <img class="absolute top-0 left-0 w-full h-auto" src="../assets/static/images/kuldkaart.png" alt="gold card" />
        </div>

        <div v-else class="self-goldcard-block-hero">
            <img class="absolute top-0 left-0 w-full h-auto" src="../assets/static/images/platinum.png" alt="platinum card" />
        </div>
        <div v-if="cardInfo" class="p-24">
            <div v-if="this.cardType === 'gold'" class="self-body-text">
                <p v-if="customerInfo.bp_collected >= 15000">
                    {{ $t('dashboard.bonus_card.platinum_reached') }}
                </p>
                <p v-else>
                    {{ $t('dashboard.bonus_card.collect') }}
                    <strong>{{ formatNumber(15000 - customerInfo.bp_collected).slice(0, -3) }}</strong>
                    {{ $t('dashboard.bonus_card.bp_to_platinum') }}
                    <a href="https://www.estravel.ee/platinum-club/">{{ $t('dashboard.bonus_card.platinum_level') }}</a>
                </p>
            </div>

            <div class="flex justify-between pt-24">
                <div>
                    <label class="self-label-sm">{{ $t('dashboard.bonus_card.bp') }}</label>
                    <span class="flex items-end">
                        <router-link
                            :to="$store.getters.isFetchingCustomerInfo ? '' : `/${$i18n.locale}/bonuspoints`"
                            class="block text-lg font-semibold underline self-animate font-heading text-primary hover:text-blue-300"
                            href="bonuspoints"
                            >{{ customerInfo.bp_collected }}</router-link
                        >
                    </span>
                </div>

                <div v-if="this.cardType === 'gold'" class="text-right">
                    <label class="text-gray-100 self-label-sm">{{ $t('dashboard.bonus_card.bp') }}</label>
                    <span class="block text-lg font-normal text-gray-100 font-heading">15 000</span>
                </div>
            </div>

            <div v-if="this.cardType === 'gold'" class="flex items-center justify-between w-full pt-4">
                <div class="flex-1">
                    <div class="relative block w-full h-8 overflow-hidden bg-white rounded-full">
                        <div class="self-goldcard-points" :style="{ width: (customerInfo.bp_collected / 15000) * 100 + '%' }"></div>
                    </div>
                </div>
                <div class="pl-16">
                    <img class="flex-shrink-0 block w-56 h-auto" src="../assets/static/images/platinum.png" alt="" />
                </div>
            </div>

            <div class="pt-24">
                <div>
                    <label class="self-label-sm">{{ $t('dashboard.bonus_card.bp_balance') }}:</label>
                    <span class="block font-semibold text-black title-lg"
                        >{{ customerInfo.bp_valid }}
                        <span class="text-md">({{ formatSum(customerInfo.bp_valid / BP_VALID_COEFFICIENT) }})</span></span
                    >
                </div>
                <div>
                    <label class="self-label-sm">{{ $t('dashboard.bonus_card.card_no') }}</label>
                    <span class="block font-semibold text-black title-lg">{{ cardInfo.customer_card_no }}</span>
                </div>
                <div v-if="expiresIn5Years()">
                    <label class="self-label-sm">{{ $t('dashboard.bonus_card.valid_to') }}</label>
                    <span class="block font-semibold text-black title-lg">{{ cardInfo.valid_to }}</span>
                </div>
            </div>

            <!-- <div v-if="this.$device.mobile" class="pt-24">
                <div class="flex items-center">
                    <img class="flex-shrink-0 block w-24 h-24 mr-8" src="../assets/static/images/mtasku.png" alt="mTasku" />
                    <div class="self-body-text self-body-text--sm" v-html="$t('dashboard.bonus_card.mTasku')"></div>
                </div>
            </div> -->

            <div v-if="this.$device.ios || this.$device.android" class="pt-24">
                <div class="flex items-center -mx-6">
                    <button
                        v-if="this.$device.ios"
                        @click="addToWallet('APPLE')"
                        :class="{ 'blinking-button': loading }"
                        type="button"
                        :aria-label="$t('dashboard.bonus_card.add_to_apple_wallet')"
                        class="flex-shrink-0 block w-auto h-40 mx-6 p-0 border-0 bg-transparent cursor-pointer"
                    >
                        <img class="flex-shrink-0 block w-auto h-40" src="../assets/static/images/apple-wallet.png" alt="apple-wallet" />
                    </button>

                    <button
                        v-if="this.$device.android"
                        @click="addToWallet('GOOGLE')"
                        :class="{ 'blinking-button': loading }"
                        type="button"
                        :aria-label="$t('dashboard.bonus_card.add_to_google_wallet')"
                        class="flex-shrink-0 block w-auto h-40 mx-6 p-0 border-0 bg-transparent cursor-pointer"
                    >
                        <googleWalletSVG class="flex-shrink-0 block w-auto h-40" />
                    </button>
                </div>
            </div>
        </div>
        <div v-else class="p-20">
            <div class="mb-24 px-24">
                <span class="block font-semibold text-black title-md"> {{ $t('dashboard.bonus_card.card_missing') }}</span>
            </div>
            <div class="px-24">
                <span class="block self-label-sm mb-24 font-semibold" v-html="$t('dashboard.bonus_card.statement')"></span>
                <div class="w-full flex items-start">
                    <input class="e5-checkbox" type="checkbox" id="goldCardAgreement" name="goldCardAgreement" v-model="agreed" />
                    <label for="goldCardAgreement"
                        ><span class="block self-label-sm" v-html="$t('dashboard.bonus_card.agreement')"></span
                    ></label>
                </div>
                <div v-if="!agreed && newCardRequested" class="text-alert self-label-sm mb-12">
                    <i>{{ $t('dashboard.bonus_card.agreement_required') }}</i>
                </div>
                <span class="block self-label-sm mb-4" v-html="$t('dashboard.bonus_card.more_details')"></span>
            </div>
            <div class="flex justify-center p-24">
                <button
                    class="self-btn-primary text-sm"
                    @click="requestNewCard()"
                    :class="{ 'blinking-button': loading }"
                    :disabled="!agreed && newCardRequested"
                >
                    {{ $t('dashboard.bonus_card.agree') }}
                </button>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import googleWalletSVG from '../assets/static/icons-src/google-wallet.svg';
import { ICustomer } from '@/domain/ICustomer';
import { Component, Vue, Watch } from 'vue-property-decorator';
import UtilsMixin from '@/scripts/utils';
// eslint-disable-next-line camelcase
import bp_config from '../../config/bpConfig';
import moment from 'moment';
@Component({
    components: {
        googleWalletSVG
    },
    mixins: [UtilsMixin]
})
export default class GoldCard extends Vue {
    private cardType = 'gold';
    loading = false;
    agreed = false;
    newCardRequested = false;
    // eslint-disable-next-line camelcase
    BP_VALID_COEFFICIENT = bp_config.BP_VALID_COEFFICIENT;
    get customerInfo(): ICustomer {
        return this.$store.getters.getCustomerInfo;
    }

    get cardInfo() {
        const cards = this.customerInfo.customer_cards;
        const goldCard = cards?.find((card) => card.card_type_name === 'Kuldkaart');
        const platinumCard = cards?.find((card) => card.card_type_name === 'Platinum Club');
        if (platinumCard) {
            this.cardType = 'platinum';
            return platinumCard;
        }
        return goldCard;
    }

    expiresIn5Years() {
        return !!this.cardInfo?.valid_to && moment(this.cardInfo.valid_to, 'DD.MM.YYYY').isSameOrBefore(moment().add(5, 'years'));
    }

    async addToWallet(walletType: 'APPLE' | 'GOOGLE') {
        this.loading = true;
        try {
            await this.$store.dispatch('addCardToWallet', { cardNumber: this.cardInfo.customer_card_no, walletType });
        } finally {
            this.loading = false;
        }
    }

    async requestNewCard() {
        if (!this.agreed) {
            this.newCardRequested = true;
            return;
        }
        this.loading = true;
        try {
            await this.$store.dispatch('requestNewCard');
        } finally {
            this.loading = false;
        }
    }

    // TODO: test if works?
    // Watch for changes in customerInfo.bp_collected
    @Watch('customerInfo.bp_collected')
    onBpCollectedChange(value: number, oldValue: number) {
        if (value >= 15000) {
            this.cardType = 'platinum';
        } else {
            this.cardType = 'gold';
        }
    }
}
</script>

<style scoped>
.blinking-button {
    animation: blink 0.65s infinite alternate;
}

@keyframes blink {
    0% {
        opacity: 1;
    }
    100% {
        opacity: 0.5;
    }
}
</style>
